import { Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WdxStopPropagationDirective } from '@wdx/shared/components/wdx-stop-propagation';
import { TranslationsService } from '@wdx/shared/utils';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface RouterLinkRendererValue {
    url: string;
    label: string;
    newTab?: boolean;
    externalLink?: boolean;
}

@Component({
    selector: 'wdx-ag-grid-link-cell-renderer',

    imports: [RouterModule, WdxStopPropagationDirective],
    templateUrl: './link-cell-renderer.component.html',
})
export class LinkRendererComponent implements ICellRendererAngularComp {
    private translationsService = inject(TranslationsService);

    public label?: string;
    public url?: string;
    public target: '_self' | '_blank' = '_self';
    public externalLink = false;

    agInit(params: ICellRendererParams<any, RouterLinkRendererValue>): void {
        if (params?.value) {
            this.updateConfig(params.value);
        }
    }

    refresh(
        params: ICellRendererParams<any, RouterLinkRendererValue>,
    ): boolean {
        if (params?.value) {
            this.updateConfig(params.value);
        }
        return true;
    }

    private updateConfig(value: RouterLinkRendererValue) {
        this.externalLink = Boolean(value.externalLink);
        this.label = this.translationsService.translateTokenisedString(
            value.label,
        );
        this.url = value.url;
        if (value?.newTab) {
            this.target = '_blank';
        }
    }
}
